export default "__VITE_ASSET__ee2b7cb4__"